// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Problem,
  ServiceCalendar,
} from '../models/index';
import {
    ProblemFromJSON,
    ProblemToJSON,
    ServiceCalendarFromJSON,
    ServiceCalendarToJSON,
} from '../models/index';

export interface GetServiceCalendarRequest {
    requestID?: string;
}

/**
 * 
 */
export class SchedulesV3Api extends runtime.BaseAPI {

    /**
     * Therefore `StopPlace\'s`, `ServiceJourney\'s` and their scheduled times and service-days might change as well (usually having change impact for e.g. on regular commuters)! <br/>The response can be cached during 1 days.
     * Get current Journey Planner timetable periods supported by underlying systems (in Switzerland we deal with yearly operating-periods changing around 2nd Sunday of december).
     */
    async getServiceCalendarRaw(requestParameters: GetServiceCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceCalendar>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/service-calendar`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceCalendarFromJSON(jsonValue));
    }

    /**
     * Therefore `StopPlace\'s`, `ServiceJourney\'s` and their scheduled times and service-days might change as well (usually having change impact for e.g. on regular commuters)! <br/>The response can be cached during 1 days.
     * Get current Journey Planner timetable periods supported by underlying systems (in Switzerland we deal with yearly operating-periods changing around 2nd Sunday of december).
     */
    async getServiceCalendar(requestParameters: GetServiceCalendarRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceCalendar> {
        const response = await this.getServiceCalendarRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
